import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col } from 'reactstrap';
import { useSelector } from 'react-redux';

import useAuth from 'src/hooks/useAuth';
import http from 'src/services/httpService';

import Drawer from 'src/componentes/drawer';
import { capitalizeFirstLetter } from 'src/utils/string';
import LoadingContainer from 'src/componentes/loading-container';
import { MODULOS } from 'src/utils/constants';
import PanelCollapse from 'src/componentes/panel-collapse';
import TourController from 'src/components/TourController/TourController';
import dashboardPageSteps from 'src/tours/DashboardPageSteps';
import matrizPageSteps from 'src/tours/MatrizResultadosSteps';
import atualizarValoresPageSteps from 'src/tours/AtualizarValoresPageSteps';
import agendaPageSteps from 'src/tours/AgendaPageSteps';
import reuniaoPageSteps from 'src/tours/ReuniaoPageSteps';
import acaoPageSteps from 'src/tours/AcaoPageSteps';
import estatisticasPageSteps from 'src/tours/EstatisticasPageSteps';
import cardMetasPageSteps from 'src/tours/CardMetasPageSteps';
import {TIPO_DASHBOARD_INDIVIDUAL} from 'src/utils/constants';

const HelpDrawer = ({
  openHelp,
  setOpenHelp,
  module,
  podeVisualizarMatriz,
  podeVisualizarValoresDesatualizados,
  podeVisualizarCardMetas,
  tipoDashboard,
}) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const modulosComprados = useSelector((state) => state.user.licenca.modulos);
  const hasRVModule = modulosComprados.find(
       (m) => m.id === MODULOS.REMUNERACAO_VARIAVEL && m.ativo
     );

  const [jaExisteFeedbackDash, setJaExisteFeedbackDash] = useState(null);
  const [jaExisteFeedbackMatriz, setJaExisteFeedbackMatriz] = useState(null);
  const [
    jaExisteFeedbackAtualizarValores,
    setJaExisteFeedbackAtualizarValores,
  ] = useState(null);
  const [jaExisteFeedbackAgenda, setJaExisteFeedbackAgenda] = useState(null);
  const [jaExisteFeedbackReuniao, setJaExisteFeedbackReuniao] = useState(null);
  const [jaExisteFeedbackAcao, setJaExisteFeedbackAcao] = useState(null);
  const [jaExisteFeedbackEstatisticas, setJaExisteFeedbackEstatisticas] =
    useState(null);
  const [jaExisteFeedbackCardMetas, setJaExisteFeedbackCardMetas] =
    useState(null);

  const [isFeedbackLoaded, setIsFeedbackLoaded] = useState(false);

  const isLoadingFeedback =
    jaExisteFeedbackDash === null ||
    jaExisteFeedbackMatriz === null ||
    jaExisteFeedbackAtualizarValores === null ||
    jaExisteFeedbackAgenda === null ||
    jaExisteFeedbackReuniao === null ||
    jaExisteFeedbackAcao === null ||
    jaExisteFeedbackEstatisticas === null ||
    jaExisteFeedbackCardMetas === null;

  const getFeedbackTour = async () => {
    try {
      var response = await http.post(
        'FeedbackTour/ObterFeedbackPorColaborador'
      );
      setJaExisteFeedbackDash(response.data.value.jaExisteFeedbackDash);
      setJaExisteFeedbackMatriz(response.data.value.jaExisteFeedbackMatriz);
      setJaExisteFeedbackAtualizarValores(
        response.data.value.jaExisteFeedbackAtualizarValores
      );
      setJaExisteFeedbackAgenda(response.data.value.jaExisteFeedbackAgenda);
      setJaExisteFeedbackReuniao(response.data.value.jaExisteFeedbackReuniao);
      setJaExisteFeedbackAcao(response.data.value.jaExisteFeedbackAcao);
      setJaExisteFeedbackEstatisticas(
        response.data.value.jaExisteFeedbackEstatisticas
      );
      setJaExisteFeedbackCardMetas(
        response.data.value.jaExisteFeedbackCardMetas
      );
      setIsFeedbackLoaded(true);
    } catch (err) {}
  };

  useEffect(() => {
    getFeedbackTour();
  }, [openHelp]);

  const dashSteps = dashboardPageSteps(
    intl,
    resources,
    jaExisteFeedbackDash,
    isLoadingFeedback
  );
  const matrizSteps = matrizPageSteps(
    intl,
    resources,
    jaExisteFeedbackMatriz,
    isLoadingFeedback
  );
  const atualizarValoresSteps = atualizarValoresPageSteps(
    intl,
    resources,
    jaExisteFeedbackAtualizarValores,
    isLoadingFeedback
  );
  const agendaSteps = agendaPageSteps(
    intl,
    resources,
    jaExisteFeedbackAgenda,
    isLoadingFeedback
  );
  const reuniaoSteps = reuniaoPageSteps(
    intl,
    resources,
    jaExisteFeedbackReuniao,
    isLoadingFeedback
  );
  const acaoSteps = acaoPageSteps(
    intl,
    resources,
    jaExisteFeedbackAcao,
    isLoadingFeedback
  );
  const estatisticasSteps = estatisticasPageSteps(
    intl,
    resources,
    jaExisteFeedbackEstatisticas,
    isLoadingFeedback
  );
  const cardMetasSteps = cardMetasPageSteps(
    intl,
    resources,
    jaExisteFeedbackCardMetas,
    isLoadingFeedback
  );

  const handleClose = () => {
    setOpenHelp(false);
  };

  const renderAll = () => (
    <>
      {module?.id == MODULOS.GESTAO_ESTRATEGICA && tipoDashboard?.id == TIPO_DASHBOARD_INDIVIDUAL.PADRAO && (
        <PanelCollapse
          open={false}
          header={capitalizeFirstLetter(
            intl.formatMessage({ id: 'label.dashboardIndividual' })
          )}
          headerStyle="text-primary"
          className="mb-3"
          style={{ width: '100%' }}
        >
          <div>
            {capitalizeFirstLetter(
              intl.formatMessage({ id: 'visualizeResumoCompleto' })
            )}
          </div>
          <div style={{ marginTop: '1rem' }}>
            <TourController
              setOpenHelp={setOpenHelp}
              redirectPath="/painel/dashboard-individual"
              steps={dashSteps}
              tourName={capitalizeFirstLetter(
                intl.formatMessage({ id: 'label.dashboardIndividual' })
              )}
            />
          </div>
        </PanelCollapse>
      )}
      {module?.id == MODULOS.REMUNERACAO_VARIAVEL && podeVisualizarMatriz && (
        <PanelCollapse
          open={false}
          header={capitalizeFirstLetter(resources.matrizderesultados)}
          headerStyle="text-primary"
          className="mb-3"
          style={{ width: '100%' }}
        >
          <div>
            {capitalizeFirstLetter(
              intl.formatMessage({ id: 'acompanheAtualizeValoresItens' })
            )}
          </div>
          <div style={{ marginTop: '1rem' }}>
            <TourController
              setOpenHelp={setOpenHelp}
              redirectPath="/acompanhar/matriz-resultado"
              steps={matrizSteps}
              tourName={capitalizeFirstLetter(resources.matrizderesultados)}
            />
          </div>
        </PanelCollapse>
      )}

      {podeVisualizarValoresDesatualizados &&
        (module?.id == MODULOS.GESTAO_ESTRATEGICA ||
          module?.id == MODULOS.REMUNERACAO_VARIAVEL) && (
          <PanelCollapse
            open={false}
            header={capitalizeFirstLetter(
              intl.formatMessage(
                { id: 'atualizarValores' },
                { valores: resources.valores }
              )
            )}
            headerStyle="text-primary"
            className="mb-3"
            style={{ width: '100%' }}
          >
            <div>
              {capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'atualizeValoresItensSobSuaResponsabilidade' },
                  { valores: resources.valores }
                )
              )}
            </div>
            <div style={{ marginTop: '1rem' }}>
              <TourController
                setOpenHelp={setOpenHelp}
                redirectPath="/minhas-tarefas/valor-desatualizado"
                steps={atualizarValoresSteps}
                tourName={capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'atualizarValores' },
                    { valores: resources.valores }
                  )
                )}
              />
            </div>
          </PanelCollapse>
        )}

      {module?.id == MODULOS.GESTAO_ESTRATEGICA && (
        <PanelCollapse
          open={false}
          header={capitalizeFirstLetter(intl.formatMessage({ id: 'agenda' }))}
          headerStyle="text-primary"
          className="mb-3"
          style={{ width: '100%' }}
        >
          <div>
            {capitalizeFirstLetter(
              intl.formatMessage({ id: 'acompanheCalendario' })
            )}
          </div>
          <div style={{ marginTop: '1rem' }}>
            <TourController
              setOpenHelp={setOpenHelp}
              redirectPath="/minhas-tarefas/minha-agenda"
              steps={agendaSteps}
              tourName={capitalizeFirstLetter(
                intl.formatMessage({ id: 'agenda' })
              )}
            />
          </div>
        </PanelCollapse>
      )}
      {(module?.id == MODULOS.GESTAO_ESTRATEGICA ||
        module?.id == MODULOS.REMUNERACAO_VARIAVEL ||
        module?.id == MODULOS.MATRIZ_ORCAMENTARIA ||
        module?.id == MODULOS.GESTAO_RISCO ||
        module?.id == MODULOS.ESCRITORIO_PROJETOS) && (
        <PanelCollapse
          open={false}
          header={capitalizeFirstLetter(
            intl.formatMessage({ id: 'cadastroReunioes' })
          )}
          headerStyle="text-primary"
          className="mb-3"
          style={{ width: '100%' }}
        >
          <div>
            {capitalizeFirstLetter(
              intl.formatMessage({ id: 'registreGerenciaReunioes' })
            )}
          </div>
          <div style={{ marginTop: '1rem' }}>
            <TourController
              setOpenHelp={setOpenHelp}
              redirectPath="/gerenciar/reuniao"
              steps={reuniaoSteps}
              tourName={capitalizeFirstLetter(
                intl.formatMessage({ id: 'cadastroReunioes' })
              )}
            />
          </div>
        </PanelCollapse>
      )}
      {(module?.id == MODULOS.GESTAO_ESTRATEGICA ||
        module?.id == MODULOS.REMUNERACAO_VARIAVEL ||
        module?.id == MODULOS.MATRIZ_ORCAMENTARIA ||
        module?.id == MODULOS.GESTAO_RISCO ||
        module?.id == MODULOS.ESCRITORIO_PROJETOS) && (
        <PanelCollapse
          open={false}
          header={capitalizeFirstLetter(
            intl.formatMessage(
              { id: 'cadastrarAcao' },
              { acao: resources.acao }
            )
          )}
          headerStyle="text-primary"
          className="mb-3"
          style={{ width: '100%' }}
        >
          <div>
            {intl.formatMessage(
              { id: 'registreGerencieAcao' },
              { planodeacao: resources.planodeacao }
            )}
          </div>
          <div style={{ marginTop: '1rem' }}>
            <TourController
              setOpenHelp={setOpenHelp}
              redirectPath="/gerenciar/acao"
              steps={acaoSteps}
              tourName={capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'cadastrarAcao' },
                  { acao: resources.acao }
                )
              )}
            />
          </div>
        </PanelCollapse>
      )}
      {module?.id == MODULOS.GESTAO_ESTRATEGICA && (
        <PanelCollapse
          open={false}
          header={capitalizeFirstLetter(
            intl.formatMessage({ id: 'estatisticas' })
          )}
          headerStyle="text-primary"
          className="mb-3"
          style={{ width: '100%' }}
        >
          <div>
            {capitalizeFirstLetter(
              intl.formatMessage({ id: 'analiseCompareEstatisticas' })
            )}
          </div>
          <div style={{ marginTop: '1rem' }}>
            <TourController
              setOpenHelp={setOpenHelp}
              redirectPath="/acompanhar/estatisticas"
              steps={estatisticasSteps}
              tourName={capitalizeFirstLetter(
                intl.formatMessage({ id: 'estatisticas' })
              )}
            />
          </div>
        </PanelCollapse>
      )}
      {(module?.id == MODULOS.REMUNERACAO_VARIAVEL ||
        module?.id == MODULOS.GESTAO_ESTRATEGICA) && hasRVModule &&
        podeVisualizarCardMetas && (
          <PanelCollapse
            open={false}
            header={capitalizeFirstLetter(resources.cardmetas)}
            headerStyle="text-primary"
            className="mb-3"
            style={{ width: '100%' }}
          >
            <div>
              {capitalizeFirstLetter(
                intl.formatMessage(
                  { id: 'subtituloOnboardCardMetas' },
                  {
                    indicadores: resources.indicadores,
                    metas: resources.metas,
                    colaboradores: resources.colaboradores,
                  }
                )
              )}
            </div>
            <div style={{ marginTop: '1rem' }}>
              <TourController
                setOpenHelp={setOpenHelp}
                redirectPath="/rv/painel/cardmeta"
                steps={cardMetasSteps}
                tourName={capitalizeFirstLetter(resources.cardmetas)}
              />
            </div>
          </PanelCollapse>
        )}
    </>
  );

  return (
    <Drawer open={openHelp} close={handleClose}>
      <LoadingContainer isLoading={false}>
        <Row>
          <Col>
            <div
              className="font-weight-bolder mb-2"
              style={{ fontSize: '22px' }}
            >
              {capitalizeFirstLetter(
                intl.formatMessage({ id: 'conhecerPlataforma' })
              )}
            </div>
          </Col>
          {isFeedbackLoaded && renderAll()}
        </Row>
      </LoadingContainer>
    </Drawer>
  );
};

export default HelpDrawer;
